import { ErrorType } from "../interfaces"

export const trowError = (error: ErrorType[], field: string) => {
    return !!error && error?.find((i: ErrorType) => i.field === field)
}

export const trowErrorMessage = (error: ErrorType[], field: string, defaultValue: string = ''): string => (!!trowError(error, field) && trowError(error, field)?.message) || defaultValue;

